/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PostFormQuestionDto = {
    formId: string;
    weight: number;
    question: string;
    questionType: PostFormQuestionDto.questionType;
    required: boolean;
    selectOptions: Array<string>;
};
export namespace PostFormQuestionDto {
    export enum questionType {
        DATE = 'DATE',
        SELECT_CHECKBOX = 'SELECT_CHECKBOX',
        SELECT_RADIO = 'SELECT_RADIO',
        TEXTAREA = 'TEXTAREA',
        TEXT = 'TEXT',
    }
}

